import { dispatcher, api } from 'react-structure-admin';

export const TREATMENT = 'TREATMENT';

export const TREATMENT_CONCLUDE = 'TREATMENT_CONCLUDE';
export const TREATMENT_CONCLUDE_FINISHED = 'TREATMENT_CONCLUDE_FINISHED';

export const TREATMENT_SELECT_PARTNER = 'TREATMENT_SELECT_PARTNER';
export const TREATMENT_SELECT_PARTNER_FINISHED =
  'TREATMENT_SELECT_PARTNER_FINISHED';

export const TREATMENT_REMOVE_PARTNER = 'TREATMENT_REMOVE_PARTNER';
export const TREATMENT_REMOVE_PARTNER_FINISHED =
  'TREATMENT_REMOVE_PARTNER_FINISHED';

export const TREATMENT_MY_TREATMENT_PARTNER = 'TREATMENT_MY_TREATMENT_PARTNER';
export const TREATMENT_MY_TREATMENT_PARTNER_FINISHED =
  'TREATMENT_MY_TREATMENT_PARTNER_FINISHED';

export const TREATMENT_ACCEPTED_TREATMENT_PARTNER =
  'TREATMENT_ACCEPTED_TREATMENT_PARTNER';
export const TREATMENT_ACCEPTED_TREATMENT_PARTNER_FINISHED =
  'TREATMENT_ACCEPTED_TREATMENT_PARTNER_FINISHED';

export const TREATMENT_CANCEL = 'TREATMENT_CANCEL';
export const TREATMENT_CANCEL_FINISHED = 'TREATMENT_CANCEL_FINISHED';

export const TREATMENT_OPEN_CANCELLATION = 'TREATMENT_OPEN_CANCELLATION';
export const TREATMENT_CLOSE_CANCELLATION = 'TREATMENT_CLOSE_CANCELLATION';

export const conclude = (id, data, onSuccess, onFail) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'treatments',
    actionType: TREATMENT_CONCLUDE,
    payload: data,
    effect: async () => api.put(`treatments/${id}/conclude`, data),
    onSuccess,
    onFail
  });
};

export const selectPartner = (id, partner, onSuccess, onFail) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'treatments',
    actionType: TREATMENT_SELECT_PARTNER,
    payload: partner,
    effect: async () => api.post(`treatments/${id}/partner`, partner),
    onSuccess,
    onFail
  });
};

export const removePartner = (id, partner, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'treatments',
    actionType: TREATMENT_REMOVE_PARTNER,
    payload: partner,
    effect: async () =>
      api.del('treatments', `${id}/partner/?partnerId=${partner?.id}`),
    onSuccess
  });
};

export const getMyTreatmentPartner = (onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'treatments',
    actionType: TREATMENT_MY_TREATMENT_PARTNER,
    effect: async () => api.fetch('treatments/my-treatment-partner'),
    onSuccess
  });
};

export const acceptedTreatmentPartner = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'treatments',
    actionType: TREATMENT_ACCEPTED_TREATMENT_PARTNER,
    payload: id,
    effect: async () =>
      api.post(
        'treatments/accepted-treatment-partner/?treatmentpartnerid=:id',
        { id }
      ),
    onSuccess
  });
};

export const cancel = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'treatments',
    actionType: TREATMENT_CANCEL,
    effect: async () => api.post('treatments/cancel', data),
    onSuccess
  });
};

export const openCancellation = () => (dispatch) => {
  dispatch(dispatcher.createAction(TREATMENT_OPEN_CANCELLATION, 'treatments'));
};

export const closeCancellation = () => (dispatch) => {
  dispatch(dispatcher.createAction(TREATMENT_CLOSE_CANCELLATION, 'treatments'));
};
